/* eslint react/no-unescaped-entities: "off" */ import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _create_class from "@swc/helpers/src/_create_class.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  button {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  padding-top: 18px;\n  padding-left: 18px;\n  width: 239px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  height: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  margin-top: 8rem;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  margin-top: 72px;\n\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "@purple-dot/design-system/Button";
import * as Sentry from "@sentry/browser";
import React from "react";
import styled from "styled-components";
import Page from "../components/common/base-page";
import { Head } from "../components/common/head";
import { SCALE_0, SCALE_NEG_1 } from "../components/common/scale";
import { Paragraph, Subtitle } from "../components/common/text";
import Logo from "../components/merchant-dashboard/Logo.svg";
var ErrorPage = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(ErrorPage, _Component);
    var _super = _create_super(ErrorPage);
    function ErrorPage() {
        _class_call_check(this, ErrorPage);
        return _super.apply(this, arguments);
    }
    _create_class(ErrorPage, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, statusCode = _props.statusCode, errorMessage = _props.errorMessage, application = _props.application, url = _props.url;
                var pageName = "".concat(statusCode || "Client", " Error");
                var displayMessage = "Oops, looks like something went wrong";
                if (statusCode) {
                    if (statusCode === 404 && !errorMessage) {
                        displayMessage = "Not Found";
                    } else if (statusCode < 500) {
                        displayMessage = errorMessage;
                    } else {
                        displayMessage = "Oops, looks like something went wrong - ".concat(statusCode);
                    }
                }
                if (application === "merchant-portal") {
                    return /*#__PURE__*/ _jsx(MerchantPortalErrorPage, {
                        pageName: pageName,
                        url: url
                    });
                }
                if (application === "embedded") {
                    return /*#__PURE__*/ _jsx(EmbeddedErrorPage, {
                        pageName: pageName,
                        displayMessage: displayMessage
                    });
                }
                return /*#__PURE__*/ _jsx(CatchallErrorPage, {
                    pageName: pageName,
                    displayMessage: displayMessage
                });
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(param) {
                var req = param.req, res = param.res, err = param.err;
                var statusCode = (res === null || res === void 0 ? void 0 : res.statusCode) || (err === null || err === void 0 ? void 0 : err.statusCode) || null;
                var errorMessage = err === null || err === void 0 ? void 0 : err.message;
                var url = (req === null || req === void 0 ? void 0 : req.originalUrl) || (window === null || window === void 0 ? void 0 : window.location.pathname);
                var application = applicationFromUrl(url);
                // Normally, render errors are caught and reported in _app.jsx using React
                // error boundaries. However, error boundaries don't work with SSR, and
                // the next place Next.js will call is here, so we report server-side render
                // crashes like this.
                // Because we handle errors originating from Express backend elsewhere, we check
                // that the error has not been handled already.
                // See https://github.com/vercel/next.js/issues/5070
                if (req && err && !err.fromBackend) {
                    Sentry.captureException(err);
                }
                return {
                    statusCode: statusCode,
                    errorMessage: errorMessage,
                    application: application,
                    url: url
                };
            }
        }
    ]);
    return ErrorPage;
}(React.Component);
function applicationFromUrl(url) {
    if (url.startsWith("/merchant-portal")) {
        return "merchant-portal";
    }
    if (url.startsWith("/embedded")) {
        return "embedded";
    }
    return "other";
}
var MerchantPortalErrorPage = styled(function(param) {
    var className = param.className, pageName = param.pageName, url = param.url;
    var storeId = url.split("/")[2];
    return /*#__PURE__*/ _jsxs(Page, {
        pageName: pageName,
        title: pageName,
        children: [
            /*#__PURE__*/ _jsx(LogoContainer, {
                children: /*#__PURE__*/ _jsx(LogoLink, {
                    icon: /*#__PURE__*/ _jsx(Logo, {
                        style: {
                            height: "100%"
                        }
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: className,
                children: [
                    /*#__PURE__*/ _jsx(ErrorTitle, {
                        centered: true,
                        children: "We're sorry, it looks like something has gone wrong"
                    }),
                    storeId && /*#__PURE__*/ _jsx(Button, {
                        primary: true,
                        style: {
                            marginTop: SCALE_NEG_1
                        },
                        children: /*#__PURE__*/ _jsx("a", {
                            href: "/merchant-portal/home",
                            children: "Take me back to the dashboard"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(SupportMessage, {
                        centered: true,
                        children: [
                            "Can’t find what you’re looking for?",
                            /*#__PURE__*/ _jsx("br", {}),
                            "Contact us:",
                            " ",
                            /*#__PURE__*/ _jsx("a", {
                                href: "mailto:support@getpurpledot.com",
                                children: "support@getpurpledot.com"
                            })
                        ]
                    })
                ]
            })
        ]
    });
})(_templateObject(), SCALE_0);
var EmbeddedErrorPage = styled(function(param) {
    var pageName = param.pageName, displayMessage = param.displayMessage, className = param.className;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                title: pageName
            }),
            /*#__PURE__*/ _jsx("div", {
                className: className,
                children: /*#__PURE__*/ _jsx(ErrorTitle, {
                    centered: true,
                    children: displayMessage
                })
            })
        ]
    });
})(_templateObject1());
var CatchallErrorPage = styled(function(param) {
    var pageName = param.pageName, displayMessage = param.displayMessage, className = param.className;
    return /*#__PURE__*/ _jsxs(Page, {
        pageName: pageName,
        title: pageName,
        children: [
            /*#__PURE__*/ _jsx(LogoContainer, {
                children: /*#__PURE__*/ _jsx(LogoLink, {
                    icon: /*#__PURE__*/ _jsx(Logo, {
                        style: {
                            height: "100%"
                        }
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: className,
                children: [
                    /*#__PURE__*/ _jsx(ErrorTitle, {
                        centered: true,
                        children: displayMessage
                    }),
                    /*#__PURE__*/ _jsxs(SupportMessage, {
                        centered: true,
                        children: [
                            "Can’t find what you’re looking for?",
                            /*#__PURE__*/ _jsx("br", {}),
                            "Contact us:",
                            " ",
                            /*#__PURE__*/ _jsx("a", {
                                href: "mailto:support@getpurpledot.com",
                                children: "support@getpurpledot.com"
                            })
                        ]
                    })
                ]
            })
        ]
    });
})(_templateObject2());
var LogoContainer = styled.div(_templateObject3());
var LogoLink = styled(function(param) {
    var className = param.className, icon = param.icon;
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: icon
    });
})(_templateObject4(), SCALE_NEG_1);
var ErrorTitle = styled(Subtitle)(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.color.danger;
});
var SupportMessage = styled(Paragraph)(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.color.primary;
});
export default ErrorPage;
